module.exports = __webpack_public_path__ + "assets/img/smartTV-module3-2.fd199192.jpg";